export class EmisorFilter {
   public rut: string;
   public razonSocial: string;
   public giro: string;
   public ciudad: string;
   public comuna: string;
   public activo: number;
   public resellerId: string;
}
